var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldSelect',{attrs:{"state":_vm.state,"label":_vm.label,"placeholder":_vm.placeholder,"is-required":_vm.isRequired,"disabled":_vm.disabled,"class-label":_vm.classLabel,"options":_vm.options},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }